import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
} from "@angular/cdk/drag-drop";
import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import {
  PageSection,
  PageContentDialogData,
  PageContentDialogResult,
} from "@shared/models/page-configuration.model";

import { translations } from "@app/i18n";

@Component({
  selector: "app-page-content-dialog",
  standalone: true,
  imports: [
    DragDropModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
  ],
  templateUrl: "./page-content-dialog.component.html",
  styleUrl: "./page-content-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageContentDialogComponent {
  readonly dialogRef = inject(MatDialogRef<PageContentDialogComponent>);
  readonly data = inject<PageContentDialogData>(MAT_DIALOG_DATA);

  readonly translations = translations;

  readonly sections = signal<PageSection[]>(
    this.data.sections.map((section) => ({ ...section })),
  );

  onDrop(event: CdkDragDrop<PageSection[]>): void {
    const updatedSections = [...this.sections()];
    moveItemInArray(updatedSections, event.previousIndex, event.currentIndex);

    // Update order values to match new positions
    updatedSections.forEach((section, index) => {
      section.order = index;
    });

    this.sections.set(updatedSections);
  }

  onToggleSection(section: PageSection): void {
    const updatedSections = this.sections().map((s) =>
      s.id === section.id ? { ...s, enabled: !s.enabled } : s,
    );
    this.sections.set(updatedSections);
  }

  onSave(): void {
    const result: PageContentDialogResult = {
      sections: this.sections(),
    };
    this.dialogRef.close(result);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  trackBySection(index: number, section: PageSection): string {
    return section.id;
  }
}
